module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.ttf
// module id = 1716
// module chunks = 11